import React from 'react';
import styled, { css } from 'styled-components';
import { handleSizesMediaQueryStyling } from 'helpers/mediaQueryStyling';
import type { ISplash } from './shared/types';
import { filterSplashesByImage } from './shared/helpers';

const splashSize = {
    sm: css`
        width: 32px;
    `,
    md: css`
        width: 64px;
    `,
    xl: css`
        width: 90px;
    `
};

const Splash = styled.img<{ $size: ISplash['size'] }>`
    ${({ $size }) =>
        $size && (typeof $size === 'object' ? handleSizesMediaQueryStyling($size, splashSize) : splashSize[$size])}
`;

export default function ImageSplash(splash: ISplash): JSX.Element | null {
    const { type, imageUrl, size = 'sm' } = splash;

    // exclude splashes that requires an imageUrl, which is missing the imageUrl
    if (filterSplashesByImage([splash]).length && !imageUrl) {
        console.warn(`${type}'s image is missing a src`);
        return null;
    }

    switch (type) {
        case 'ProHairCare':
        case 'Modiface':
        case 'Derma':
        case 'Dba':
        case 'Taenk':
        case 'ProSkin':
        case 'BeautyPharmacy':
            return <Splash src={imageUrl} alt="" $size={size} />;
        default:
            console.warn(`${type} is not reconized as a valid ImageSplash type`);
            return null;
    }
}
